/**
 * View component for /answers/:answerId
 *
 * Displays a single answer from the 'byId' map in the answer reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as answerActions from '../answerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import answer components
import AnswerLayout from '../components/AnswerLayout.js.jsx';

// import answer css modules
import answerStyles from '../answerModuleStyles.css';


class SingleAnswer extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(answerActions.fetchSingleIfNeeded(match.params.answerId));
  }

  render() {
    const { answerStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual answer object from the map
     */
    const selectedAnswer = answerStore.selected.getItem();

    const isEmpty = (
      !selectedAnswer
      || !selectedAnswer._id
      || answerStore.selected.didInvalidate
    );

    return (
      <AnswerLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Answer </h3>
              {isEmpty ?
                (answerStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: answerStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedAnswer.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Answer </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the Answer would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </AnswerLayout>
    )
  }
}

SingleAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    answerStore: store.answer
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleAnswer)
);



// WEBPACK FOOTER //
// modules/answer/views/SingleAnswer.js.jsx